"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ColumnConfig_1 = tslib_1.__importDefault(require("./ColumnConfig"));
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
class WCAGDateFieldColumnConfig extends ColumnConfig_1.default {
    constructor(args) {
        super(args);
        this.dateFieldMap = new Map(); // Need to use Map because it's a key and value are objects
        const { isEnabled } = args;
        const that = this;
        this.renderer = {
            render(ctx, obj) {
                const datefield = new fmko_ts_widgets_1.WCAGDateField({
                    hint: null,
                    label: "Datofelt",
                    position: args.datepickerPosition,
                    labelHidden: true,
                    placeholder: "dd-mm-åååå"
                });
                datefield.setValue(obj.date);
                datefield.setEnabled(isEnabled?.(obj.data) ?? true);
                that.dateFieldMap.set(obj.data, datefield);
                ctx.setWidget(datefield);
            },
            canRender(_o) {
                return true;
            }
        };
    }
    getDateFieldMap() {
        return this.dateFieldMap;
    }
    getDateFields() {
        return Array.from(this.dateFieldMap.values());
    }
    getDateFieldFromData(data) {
        const dateField = this.dateFieldMap.get(data);
        if (!dateField) {
            throw new Error("Only use the data references that you used to call grid.setData with. " +
                "A possible reason for this error could be that you have cloned one of the references");
        }
        return dateField;
    }
    clear() {
        this.dateFieldMap.clear();
    }
    getData(data) {
        return { data: data, date: this.mapDataToTD(data) };
    }
}
exports.default = WCAGDateFieldColumnConfig;
//# sourceMappingURL=WCAGDateFieldColumnConfig.js.map